import { render, staticRenderFns } from "./YKToDoListDetail.vue?vue&type=template&id=3c3d6c6b&scoped=true&"
import script from "./YKToDoListDetail.vue?vue&type=script&lang=js&"
export * from "./YKToDoListDetail.vue?vue&type=script&lang=js&"
import style0 from "./YKToDoListDetail.vue?vue&type=style&index=0&id=3c3d6c6b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c3d6c6b",
  null
  
)

export default component.exports